import { Component } from '@angular/core';
import { Color, Masks, Unmasks } from '@lsq-frontend/common-ui';
import { FeatureFlagService, Icons } from '@lsq-frontend/common-ui';
import { ModalWorkflowService } from '@lsq-frontend/common-ui';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';
import { TwoFactorService } from '../two-factor.service';

@Component({
    selector: 'edit-two-factor-phone-modal',
    template: `
        <form
            class="modal-content"
            [formGroup]="twoFactorService.userPhoneNumberToVerifyForm"
            (ngSubmit)="handleSubmit()"
        >
            <div class="modal-header" [style.padding-top]="'3rem'">
                <h2 i18n>Edit Multi-Factor Authentication</h2>
                <lsq-button
                    appearance="transparent"
                    class="close"
                    ariaLabel="Close"
                    (buttonClick)="modalWorkflowService.hideWorkflow()"
                >
                    <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="colors.Black">
                    </lsq-icon>
                </lsq-button>
            </div>
            <div class="modal-body">
                <p i18n>
                    We’ll text a one-time verification code via SMS to verify your identity. By
                    providing your mobile number, you agree to receive text messages.
                </p>
                <div>
                    <lsq-phone-input
                        *ngIf="countryCodePhoneInputIsOn$ | async"
                        name="new-user-phone-number"
                        label="Mobile Phone Number"
                        [hasInnerLabel]="true"
                        [group]="twoFactorService.userPhoneNumberToVerifyForm"
                        formControlName="phoneNumber"
                    ></lsq-phone-input>
                    <lsq-input
                        *ngIf="!(countryCodePhoneInputIsOn$ | async)"
                        formControlName="phoneNumber"
                        [name]="'new-user-phone-number'"
                        [label]="'Mobile Phone Number'"
                        [mask]="phoneMask"
                        [unmask]="phoneUnmask"
                    >
                    </lsq-input>
                </div>
            </div>
            <div class="modal-footer">
                <div class="modal-footer-left">
                    <lsq-button
                        i18n
                        size="sm"
                        type="button"
                        appearance="secondary"
                        (buttonClick)="modalWorkflowService.hideWorkflow()"
                    >
                        Cancel
                    </lsq-button>
                </div>
                <div class="modal-footer-right">
                    <lsq-button
                        i18n
                        size="sm"
                        type="submit"
                        [disabled]="twoFactorService.userPhoneNumberToVerifyForm.invalid"
                        [submitting]="submitting"
                    >
                        Send Code
                    </lsq-button>
                </div>
            </div>
        </form>
    `,
    styleUrls: ['./edit-two-factor-phone-modal.component.scss']
})
export class EditTwoFactorPhoneModalComponent {
    public readonly icons = Icons;
    public readonly colors = Color;
    public readonly phoneMask = Masks.PhoneMask;
    public readonly phoneUnmask = Unmasks.PhoneUnmask;
    public submitting = false;

    public countryCodePhoneInputIsOn$ = this._featureFlagService.isOn(
        FeatureFlags.CountryCodePhoneInput
    );

    constructor(
        public modalWorkflowService: ModalWorkflowService,
        public twoFactorService: TwoFactorService,
        private _featureFlagService: FeatureFlagService
    ) {}

    public async handleSubmit(): Promise<void> {
        this.twoFactorService.userPhoneNumberToVerifyForm
            .get('phoneNumber')
            .updateValueAndValidity({ emitEvent: false });
        if (this.twoFactorService.userPhoneNumberToVerifyForm.valid) {
            this.submitting = true;
            await this.twoFactorService.sendIdentityVerificationToPhone();
            this.modalWorkflowService.nextStep();
            this.submitting = false;
        } else {
            this.twoFactorService.userPhoneNumberToVerifyForm.markAllAsTouched();
        }
    }
}
